module.exports = __webpack_public_path__ + "static/media/Fernando Fé e Glauco Lima_front cover.bc285100.jpg";